import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const testDataApi = {
  getAll: (params?: { project_id?: number; folder_id?: number }) =>
    api.get('/test-data', { params }),
  
  getById: (id: number) =>
    api.get(`/test-data/${id}`),
  
  create: (data: any) =>
    api.post('/test-data', data),
  
  update: (id: number, data: any) =>
    api.put(`/test-data/${id}`, data),
  
  delete: (id: number) =>
    api.delete(`/test-data/${id}`),
}; 